import { Building, Briefcase, User } from 'lucide-react';

export const USER_TYPES = {
  member: {
    label: 'Membre',
    icon: User,
    color: 'bg-green-700',
    bgLight: 'bg-green-50',
    textColor: 'text-green-700'
  },
  cooper: {
    label: "COOPER'S",
    icon: Building,
    color: 'bg-purple-700',
    bgLight: 'bg-purple-50',
    textColor: 'text-purple-700'
  },
  expert: {
    label: 'Expert',
    icon: Briefcase,
    color: 'bg-sky-700',
    bgLight: 'bg-sky-50',
    textColor: 'text-sky-700'
  }
};
